import React, { useState } from 'react';
import { Card, Table, Badge, Button } from '../ui';
import { Search, Plus, Trash2, ArrowLeft, Check, Clock, ChevronRight, X, Download, Filter, Users, Phone, Shield, Mail, User, Landmark, CreditCard, CheckCircle, Lock, ArrowRight, ChevronDown } from 'lucide-react';
export function AliasManagementView() {
  const [searchQuery, setSearchQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
  const [linkageType, setLinkageType] = useState<'universal' | 'individual'>('universal');
  // Data matching the screenshot/spec
  const aliases = [{
    id: 'CUST-001',
    name: 'Sarah Jenkins',
    type: 'Individual',
    alias: '+242 555 0101',
    linkage: 'Universal',
    bank: 'Royal Bank of Canada',
    status: 'Active'
  }, {
    id: 'CUST-002',
    name: 'Acme Logistics Ltd.',
    type: 'Business',
    alias: '+242 555 0202',
    linkage: 'Individual',
    bank: 'Scotiabank',
    status: 'Active'
  }, {
    id: 'CUST-003',
    name: 'Michael Thompson',
    type: 'Individual',
    alias: '+242 555 0303',
    linkage: 'Universal',
    bank: 'Bank of The Bahamas',
    status: 'Pending'
  }, {
    id: 'CUST-004',
    name: 'Island Resorts Inc.',
    type: 'Business',
    alias: '+242 555 0404',
    linkage: 'Individual',
    bank: 'First Caribbean Int.',
    status: 'Active'
  }, {
    id: 'CUST-005',
    name: 'David Miller',
    type: 'Individual',
    alias: '+242 555 0505',
    linkage: 'Universal',
    bank: 'Commonwealth Bank',
    status: 'Active'
  }];
  const customerMappings = [{
    alias: '+242 555 0101',
    account: '1000123456',
    verified: true
  }, {
    alias: 'sarah.j@example.com',
    account: '1000123456',
    verified: false
  }];
  // Detail View
  if (selectedCustomer) {
    return <div className="space-y-6" data-id="element-74">
        <div className="flex items-center space-x-4 mb-6" data-id="element-75">
          <Button variant="ghost" onClick={() => setSelectedCustomer(null)} leftIcon={<ArrowLeft className="h-4 w-4" data-id="element-77" />} data-id="element-76">
            Back to Directory
          </Button>
          <div data-id="element-78">
            <h2 className="text-2xl font-serif font-bold text-bank-navy" data-id="element-79">
              {selectedCustomer.name}
            </h2>
            <p className="text-slate-500 text-sm" data-id="element-80">
              Customer ID: {selectedCustomer.id} • Type: {selectedCustomer.type}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-81">
          <div className="lg:col-span-2 space-y-6" data-id="element-82">
            <Card title="Linkage Configuration" data-id="element-83">
              <div className="p-4 bg-slate-50 rounded-lg border border-slate-200 mb-6" data-id="element-84">
                <h4 className="text-sm font-semibold text-slate-700 mb-3" data-id="element-85">
                  Linkage Mode
                </h4>
                <div className="flex items-center space-x-4" data-id="element-86">
                  <button onClick={() => setLinkageType('universal')} className={`flex-1 p-3 rounded-md border transition-colors text-left ${linkageType === 'universal' ? 'bg-bank-navy text-white border-bank-navy' : 'bg-white text-slate-700 border-slate-200 hover:border-slate-300'}`} data-id="element-87">
                    <p className="font-semibold text-sm" data-id="element-88">Universal Default</p>
                    <p className={`text-xs mt-1 ${linkageType === 'universal' ? 'text-blue-200' : 'text-slate-500'}`} data-id="element-89">
                      One account receives all payments
                    </p>
                  </button>
                  <button onClick={() => setLinkageType('individual')} className={`flex-1 p-3 rounded-md border transition-colors text-left ${linkageType === 'individual' ? 'bg-bank-navy text-white border-bank-navy' : 'bg-white text-slate-700 border-slate-200 hover:border-slate-300'}`} data-id="element-90">
                    <p className="font-semibold text-sm" data-id="element-91">Individual Mapping</p>
                    <p className={`text-xs mt-1 ${linkageType === 'individual' ? 'text-blue-200' : 'text-slate-500'}`} data-id="element-92">
                      Each alias maps to specific account
                    </p>
                  </button>
                </div>
              </div>

              <Table columns={[{
              header: 'Alias',
              accessorKey: 'alias' as const
            }, {
              header: 'Maps To Account',
              accessorKey: 'account' as const
            }, {
              header: 'Status',
              accessorKey: 'verified' as const,
              cell: (item: any) => <Badge variant={item.verified ? 'success' : 'warning'} data-id="element-94">
                        {item.verified ? 'Verified' : 'Pending'}
                      </Badge>
            }, {
              header: 'Actions',
              cell: () => <Button variant="ghost" size="sm" data-id="element-95">
                        <Trash2 className="h-4 w-4 text-red-600" data-id="element-96" />
                      </Button>
            }]} data={customerMappings} data-id="element-93" />
            </Card>
          </div>

          <div className="space-y-6" data-id="element-97">
            <Card title="Verification Status" data-id="element-98">
              <div className="relative py-4" data-id="element-99">
                <div className="absolute left-4 top-4 bottom-4 w-0.5 bg-slate-200" data-id="element-100" />
                <div className="space-y-8 relative" data-id="element-101">
                  <div className="flex items-start" data-id="element-102">
                    <div className="relative z-10 flex items-center justify-center w-8 h-8 rounded-full bg-green-100 border-2 border-green-500" data-id="element-103">
                      <Check className="h-4 w-4 text-green-600" data-id="element-104" />
                    </div>
                    <div className="ml-4" data-id="element-105">
                      <p className="text-sm font-bold text-bank-navy" data-id="element-106">
                        ID Verified
                      </p>
                      <p className="text-xs text-slate-500" data-id="element-107">
                        National ID check passed
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-108">
                    <div className="relative z-10 flex items-center justify-center w-8 h-8 rounded-full bg-green-100 border-2 border-green-500" data-id="element-109">
                      <Check className="h-4 w-4 text-green-600" data-id="element-110" />
                    </div>
                    <div className="ml-4" data-id="element-111">
                      <p className="text-sm font-bold text-bank-navy" data-id="element-112">
                        OTP Sent
                      </p>
                      <p className="text-xs text-slate-500" data-id="element-113">
                        Mobile verification complete
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-114">
                    <div className="relative z-10 flex items-center justify-center w-8 h-8 rounded-full bg-yellow-50 border-2 border-yellow-500" data-id="element-115">
                      <Clock className="h-4 w-4 text-yellow-600" data-id="element-116" />
                    </div>
                    <div className="ml-4" data-id="element-117">
                      <p className="text-sm font-bold text-bank-navy" data-id="element-118">
                        Bank Confirmed
                      </p>
                      <p className="text-xs text-slate-500" data-id="element-119">
                        Waiting for bank approval
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>;
  }
  // Main Directory View
  return <div className="space-y-8 relative" data-id="element-120">
      {/* Page Header */}
      <div className="flex justify-between items-start" data-id="element-121">
        <div data-id="element-122">
          <h2 className="text-3xl font-serif font-bold text-bank-navy" data-id="element-123">
            Alias Management Directory
          </h2>
          <p className="text-slate-500 text-lg mt-1" data-id="element-124">
            Central registry for linking customer identifiers to bank accounts
          </p>
        </div>
        <div className="flex space-x-3" data-id="element-125">
          <Button variant="outline" leftIcon={<Download className="h-4 w-4" data-id="element-127" />} data-id="element-126">
            Export Registry
          </Button>
          <Button variant="primary" className="bg-bank-navy hover:bg-bank-navy-light" leftIcon={<Plus className="h-4 w-4" data-id="element-129" />} onClick={() => setShowModal(true)} data-id="element-128">
            Register New Alias
          </Button>
        </div>
      </div>

      {/* Stat Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-130">
        {/* Card 1 */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm flex items-center space-x-4" data-id="element-131">
          <div className="h-12 w-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0" data-id="element-132">
            <Users className="h-6 w-6 text-blue-600" data-id="element-133" />
          </div>
          <div data-id="element-134">
            <p className="text-xs font-bold text-slate-500 tracking-wider uppercase mb-1" data-id="element-135">
              Total Registered Aliases
            </p>
            <p className="text-3xl font-bold text-bank-navy" data-id="element-136">142,893</p>
          </div>
        </div>

        {/* Card 2 */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm flex items-center space-x-4" data-id="element-137">
          <div className="h-12 w-12 rounded-full bg-green-50 flex items-center justify-center flex-shrink-0" data-id="element-138">
            <Phone className="h-6 w-6 text-green-600" data-id="element-139" />
          </div>
          <div data-id="element-140">
            <p className="text-xs font-bold text-slate-500 tracking-wider uppercase mb-1" data-id="element-141">
              Phone Numbers Linked
            </p>
            <p className="text-3xl font-bold text-bank-navy" data-id="element-142">98,450</p>
          </div>
        </div>

        {/* Card 3 */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm flex items-center space-x-4" data-id="element-143">
          <div className="h-12 w-12 rounded-full bg-amber-50 flex items-center justify-center flex-shrink-0" data-id="element-144">
            <Shield className="h-6 w-6 text-amber-600" data-id="element-145" />
          </div>
          <div data-id="element-146">
            <p className="text-xs font-bold text-slate-500 tracking-wider uppercase mb-1" data-id="element-147">
              Verified Mappings
            </p>
            <p className="text-3xl font-bold text-bank-navy" data-id="element-148">127,341</p>
          </div>
        </div>

        {/* Card 4 */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm flex items-center space-x-4" data-id="element-149">
          <div className="h-12 w-12 rounded-full bg-purple-50 flex items-center justify-center flex-shrink-0" data-id="element-150">
            <Mail className="h-6 w-6 text-purple-600" data-id="element-151" />
          </div>
          <div data-id="element-152">
            <p className="text-xs font-bold text-slate-500 tracking-wider uppercase mb-1" data-id="element-153">
              Email Addresses Linked
            </p>
            <p className="text-3xl font-bold text-bank-navy" data-id="element-154">44,443</p>
          </div>
        </div>
      </div>

      {/* Search & Filters */}
      <div className="flex justify-between items-center space-x-4" data-id="element-155">
        <div className="relative flex-1" data-id="element-156">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-slate-400" data-id="element-157" />
          <input type="text" placeholder="Search by Name, Phone, or Business ID..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-bank-navy/20 focus:border-bank-navy" data-id="element-158" />
        </div>
        <div className="flex space-x-3" data-id="element-159">
          <Button variant="outline" leftIcon={<Filter className="h-4 w-4" data-id="element-161" />} data-id="element-160">
            Filter Status
          </Button>
          <div className="relative" data-id="element-162">
            <select className="appearance-none bg-white border border-slate-300 text-slate-700 py-2 pl-4 pr-10 rounded-md focus:outline-none focus:ring-2 focus:ring-bank-navy focus:border-transparent h-10 text-sm font-medium" data-id="element-163">
              <option data-id="element-164">All Linkage Types</option>
              <option data-id="element-165">Universal</option>
              <option data-id="element-166">Individual</option>
            </select>
            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" data-id="element-167" />
          </div>
        </div>
      </div>

      {/* Customer Table */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-168">
        <Table columns={[{
        header: 'CUSTOMER NAME',
        accessorKey: 'name' as const,
        className: 'font-medium text-slate-500 text-xs tracking-wider uppercase',
        cell: (item: any) => <div data-id="element-170">
                  <div className="font-medium text-slate-900" data-id="element-171">{item.name}</div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-172">
                    {item.type} • {item.id}
                  </div>
                </div>
      }, {
        header: 'PRIMARY ALIAS',
        accessorKey: 'alias' as const,
        className: 'font-medium text-slate-500 text-xs tracking-wider uppercase'
      }, {
        header: 'LINKAGE TYPE',
        accessorKey: 'linkage' as const,
        className: 'font-medium text-slate-500 text-xs tracking-wider uppercase'
      }, {
        header: 'PRIMARY BANK',
        accessorKey: 'bank' as const,
        className: 'font-medium text-slate-500 text-xs tracking-wider uppercase'
      }, {
        header: 'STATUS',
        accessorKey: 'status' as const,
        className: 'font-medium text-slate-500 text-xs tracking-wider uppercase',
        cell: (item: any) => <Badge variant={item.status === 'Active' ? 'success' : 'warning'} data-id="element-173">
                  {item.status}
                </Badge>
      }, {
        header: 'ACTIONS',
        className: 'font-medium text-slate-500 text-xs tracking-wider uppercase',
        cell: () => <button className="flex items-center text-sm font-medium text-bank-navy hover:text-bank-navy-light transition-colors" data-id="element-174">
                  Manage <ArrowRight className="ml-1 h-4 w-4" data-id="element-175" />
                </button>
      }]} data={aliases} onRowClick={item => setSelectedCustomer(item)} data-id="element-169" />
      </div>

      {/* Registration Modal */}
      {showModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 backdrop-blur-sm" data-id="element-176">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden flex flex-col max-h-[90vh]" data-id="element-177">
            {/* Modal Header */}
            <div className="px-6 py-4 bg-bank-navy flex justify-between items-center flex-shrink-0" data-id="element-178">
              <h3 className="text-lg font-medium text-white" data-id="element-179">
                Link an alias to a bank account
              </h3>
              <button onClick={() => setShowModal(false)} className="text-white/70 hover:text-white transition-colors" data-id="element-180">
                <X className="h-5 w-5" data-id="element-181" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 space-y-8 overflow-y-auto" data-id="element-182">
              {/* Section 1: Identity */}
              <div className="space-y-4" data-id="element-183">
                <div className="flex items-center space-x-3" data-id="element-184">
                  <div className="h-6 w-6 rounded-full bg-bank-navy text-white flex items-center justify-center text-xs font-bold" data-id="element-185">
                    1
                  </div>
                  <h4 className="text-lg font-serif font-bold text-bank-navy" data-id="element-186">
                    Identity
                  </h4>
                </div>

                <div className="pl-9 space-y-4" data-id="element-187">
                  <div data-id="element-188">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-189">
                      Full Name / Business Name
                    </label>
                    <div className="relative" data-id="element-190">
                      <User className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-slate-400" data-id="element-191" />
                      <input type="text" className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg shadow-sm focus:ring-2 focus:ring-bank-navy focus:border-bank-navy" placeholder="e.g. John Doe or Acme Corp" data-id="element-192" />
                    </div>
                  </div>

                  <div data-id="element-193">
                    <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-194">
                      Customer Type
                    </label>
                    <div className="flex space-x-6" data-id="element-195">
                      <label className="flex items-center cursor-pointer" data-id="element-196">
                        <input type="radio" name="customerType" className="h-4 w-4 text-bank-navy border-slate-300 focus:ring-bank-navy" defaultChecked data-id="element-197" />
                        <span className="ml-2 text-sm text-slate-700" data-id="element-198">
                          Individual
                        </span>
                      </label>
                      <label className="flex items-center cursor-pointer" data-id="element-199">
                        <input type="radio" name="customerType" className="h-4 w-4 text-bank-navy border-slate-300 focus:ring-bank-navy" data-id="element-200" />
                        <span className="ml-2 text-sm text-slate-700" data-id="element-201">
                          Business
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section 2: The Alias */}
              <div className="space-y-4" data-id="element-202">
                <div className="flex items-center space-x-3" data-id="element-203">
                  <div className="h-6 w-6 rounded-full bg-bank-navy text-white flex items-center justify-center text-xs font-bold" data-id="element-204">
                    2
                  </div>
                  <h4 className="text-lg font-serif font-bold text-bank-navy" data-id="element-205">
                    The Alias
                  </h4>
                </div>

                <div className="pl-9 space-y-4" data-id="element-206">
                  <div data-id="element-207">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-208">
                      Alias Type
                    </label>
                    <div className="relative" data-id="element-209">
                      <select className="w-full pl-4 pr-10 py-2 border border-slate-300 rounded-lg shadow-sm focus:ring-2 focus:ring-bank-navy focus:border-bank-navy appearance-none bg-white" data-id="element-210">
                        <option data-id="element-211">Mobile Number (MSISDN)</option>
                        <option data-id="element-212">Email Address</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" data-id="element-213" />
                    </div>
                  </div>

                  <div data-id="element-214">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-215">
                      Alias Value
                    </label>
                    <div className="relative" data-id="element-216">
                      <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-slate-400" data-id="element-217" />
                      <input type="text" className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg shadow-sm focus:ring-2 focus:ring-bank-navy focus:border-bank-navy" placeholder="+242 555 0123" data-id="element-218" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Section 3: The Target Account */}
              <div className="space-y-4" data-id="element-219">
                <div className="flex items-center space-x-3" data-id="element-220">
                  <div className="h-6 w-6 rounded-full bg-bank-navy text-white flex items-center justify-center text-xs font-bold" data-id="element-221">
                    3
                  </div>
                  <h4 className="text-lg font-serif font-bold text-bank-navy" data-id="element-222">
                    The Target Account
                  </h4>
                </div>

                <div className="pl-9 space-y-4" data-id="element-223">
                  <div data-id="element-224">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-225">
                      Bank Name
                    </label>
                    <div className="relative" data-id="element-226">
                      <Landmark className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-slate-400" data-id="element-227" />
                      <select className="w-full pl-10 pr-10 py-2 border border-slate-300 rounded-lg shadow-sm focus:ring-2 focus:ring-bank-navy focus:border-bank-navy appearance-none bg-white text-slate-500" data-id="element-228">
                        <option data-id="element-229">Select a bank...</option>
                        <option data-id="element-230">Royal Bank of Canada</option>
                        <option data-id="element-231">Scotiabank</option>
                        <option data-id="element-232">Bank of The Bahamas</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" data-id="element-233" />
                    </div>
                  </div>

                  <div data-id="element-234">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-235">
                      Account Number
                    </label>
                    <div className="relative" data-id="element-236">
                      <CreditCard className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-slate-400" data-id="element-237" />
                      <input type="text" className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg shadow-sm focus:ring-2 focus:ring-bank-navy focus:border-bank-navy" placeholder="0000 0000 0000" data-id="element-238" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="px-6 py-4 bg-slate-50 border-t border-slate-200 flex justify-between items-center flex-shrink-0" data-id="element-239">
              <div className="flex items-center text-slate-500" data-id="element-240">
                <Lock className="h-3 w-3 mr-1.5" data-id="element-241" />
                <span className="text-xs font-medium" data-id="element-242">Secure Registration</span>
              </div>
              <div className="flex space-x-3" data-id="element-243">
                <button onClick={() => setShowModal(false)} className="px-4 py-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors" data-id="element-244">
                  Cancel
                </button>
                <button onClick={() => setShowModal(false)} className="px-4 py-2 bg-bank-navy text-white text-sm font-medium rounded-lg hover:bg-bank-navy-light transition-colors flex items-center shadow-sm" data-id="element-245">
                  <CheckCircle className="h-4 w-4 mr-2" data-id="element-246" />
                  Submit for Verification
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}